import { populateSEO } from "@shared/lib";
import { FeaturesComponent, HomePage, PageData, WidgetsComponent } from "../types";
import { ApiInstance } from "./instance";

export class HomePageApi extends ApiInstance {
  constructor(locale = "id-ID") {
    super(locale);
  }

  getHomePageData(): Promise<PageData<HomePage>> {
    const query = {
      populate: {
        contents: {
          on: {
            [WidgetsComponent.HomeHeroSection]: {
              populate: [
                "leftBannerDesktop",
                "leftBannerMobile",
                "rightBannerDesktop",
                "rightBannerMobile",
                "searchbar",
              ]
            },
            [WidgetsComponent.VacancyRecommendationSection]: {
              populate: [
                "moreButton.color",
                "vacancyCard",
                "vacancyCard.salaryInfo",
                "vacancyCard.platformInfo",
                "vacancyCard.platformInfo.defaultPlatformLogo",
              ]
            },
            [WidgetsComponent.PopularJobFunctionSection]: {
              populate: [
                "button.color",
              ]
            },
            [FeaturesComponent.ContentWithImageSection]: {
              populate: [
                "imageDesktop",
                "imageMobile",
                "subtitle.icon",
                "button.icon",
                "features.icon",
              ]
            },
            [WidgetsComponent.HomeBentoGridSection]: {
              populate: [
                "cards",
                "cards.subtitle.icon",
                "cards.image",
                "cards.backgroundImage",
                "cards.button.icon",
                "cards.button.color",
              ],
            },
            [WidgetsComponent.TestimonySection]: {
              populate: [
                "testimonies.avatar",
              ],
            },
            [WidgetsComponent.VacancyCtaSection]: {
              populate: [
                "button.icon",
                "button.color",
                "image",
                "backgroundDesktop",
                "backgroundMobile",
              ],
            }
          },
        },
        ...populateSEO,
      },
    };

    return this._SendWithQuery("/home-page", query);
  }
}
